import { FusionSettingsApi, useFusionSettingsAPI } from "melco-shared-logic";
import { useCallback } from "react";
import { BasicSettingsResult } from "./useBasicSettings";

const initialValue = { settings: undefined };

export const useFusionBasicSettings = () => {
  const handleRequest = useCallback(async (api: FusionSettingsApi) => {
    const {
      default_embroidery_production_file_format,
      measurement_unit,
      enable_production_links,
    } = await api.settingsGetFusionAppSetting();

    return {
      settings: {
        default_embroidery_production_file_format,
        measurement_unit,
        enable_production_links,
      },
    };
  }, []);

  return useFusionSettingsAPI<BasicSettingsResult>({
    initialValue,
    handleRequest,
  });
};
